import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ASSETS_PATH } from 'src/app/core/config';
import { UserBasicInfo } from 'src/app/core/models/user.model';
import { UpdateMyRoleTypesModel } from 'src/app/core/models/volunteer-role.model';
import { AlertService } from 'src/app/core/services/alert.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { UserService } from 'src/app/core/services/user.service';
import { VolunteerRoleService } from 'src/app/core/services/volunteer-role.service';

@Component({
  selector: 'app-update-my-role-settings',
  templateUrl: './update-my-role-settings.component.html',
  styleUrls: ['./update-my-role-settings.component.scss']
})
export class UpdateMyRoleSettingsComponent implements OnInit, AfterViewInit {
  userBasicInfo = new UserBasicInfo();
  checkedIds = [];
  roleTypes = [];
  assetsPath = ASSETS_PATH;
  isImage = false;

  constructor(private authService: AuthService,
    private alertService: AlertService,
    private userService: UserService,
    private loadingService: LoadingService,
    private router: Router,
    private volunteerRoleService: VolunteerRoleService) { }

  ngOnInit(): void {
    this.loadingService.setLoading(true);
    this.userService.getUserBasicInfo().subscribe(response => {
      if (response.success) {
        this.userBasicInfo = response;
        if (this.userBasicInfo.image !== null && this.userBasicInfo.image !== ""){
          this.isImage = true;
        }
        this.loadingService.setLoading(false);
      }
    },
      (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
        console.log('Error --->:', error);
      });
    this.getRoleTypes();
  }

  ngAfterViewInit() {
    this.getMyRoleTypes();
  }

  getRoleTypes() {
    this.loadingService.setLoading(true);
    this.volunteerRoleService.getRoles().subscribe(response => {
      if (response.success) {
        this.roleTypes = response.roles;
        console.log(this.roleTypes);
        this.loadingService.setLoading(false);
      }
    },
      (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
        console.log('Error --->:', error);
      })
  }

  getMyRoleTypes(){
    this.volunteerRoleService.getMyRoles().subscribe(response => {
      if (response.success) {
        this.checkedIds = response.roleIds;
        this.loadingService.setLoading(false);
      }
    },
      (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
        console.log('Error --->:', error);
      })
  }

  checkItemExists(value: string){
    if (this.checkedIds.indexOf(value) !== -1){
      return true;
    }
    return false;
  }
  
  addItem(value: string){
    if(!this.checkItemExists(value)){
      this.checkedIds.push(value);
    } else{
      let index = this.checkedIds.indexOf(value);
      this.checkedIds.splice(index, 1);
    }
    console.log(this.checkedIds);
  }

  update(){
    console.log(this.checkedIds);
    let model = new UpdateMyRoleTypesModel();
    model.roleIds = this.checkedIds;
    this.volunteerRoleService.updateMyRoles(model).subscribe(response => {
      if (response.success) {
        this.alertService.alert('Başarılı', 'Gönüllü rolleriniz başarılı bir şekilde güncellenmiştir!', 'success');
        this.router.navigate(['/update-my-role-settings']);
      } else {
        this.alertService.alert('Hata!', response.errors[0], 'error');
      }
      this.loadingService.setLoading(false);
    }, (error) => {
      this.loadingService.setLoading(false);
      this.alertService.alert('Hata!', error.error.Message, 'error');
      console.log('Error --->:', error);
    })
  }

  displayMessage(value: any){
    if (value === "Destek Gönüllüsü") {
      this.alertService.alert('Destek Gönüllüsü', 'Bilim Kahramanları Derneği tarafından gerçekleştirilen çeşitli etkinliklerde kaynak geliştirme, iletişim, ofis içi destek, çeviri çalışmalarında gönüllü desteği verebilirsiniz.', 'info');
    }
    else if (value === "Program Gönüllüsü"){
      this.alertService.alert('Program Gönüllüsü', 'Bilim Kahramanları Derneği tarafından yürütülen Bilim Kahramanları Buluşuyor, Minik Bilim Kahramanları Buluşuyor ve Dünya Robot Olimpiyatları gibi programlarda farklı alanlarda gönüllü desteği verebilirsiniz. Hakem, jüri ve gönüllü olarak farklı alt kırımları olan Program Gönüllüsü olmak isterseniz bu başlığı işaretleyebilirsiniz. Kaydınızın ardından ilgilendiğiniz alanlara yönelik duyurulardan detaylı seçiminizi yapabilirsiniz.', 'info');
    }
    else if (value === "Proje Gönüllüsü"){
      this.alertService.alert('Proje Gönüllüsü', 'Bilim Kahramanları Derneği tarafından yürütülen çocuklara yönelik projelerde gönüllü desteği verebilirsiniz.', 'info');
    }
  }

}
